<template>
	<div class="Box">
		<!-- <div class="Menu">
			<ul>
				<li class="menuText" @click="Menuscroll(1)">新闻动态</li>
				<li class="menuText" @click="Menuscroll(2)">获奖履历</li>
			</ul>
		</div> -->
		<!-- 新闻动态 -->
		<div class="newsHeight">
			<div class="title">
				<div class="bgimg">
					<img src="../assets/img/dd01.png" alt="">
				</div>
				<div class="text" @mouseenter="titleEnter($event)" @mouseleave="titleLeave($event)">
					<p class="name">新闻动态</p>
					<p class="english">NEWS</p>
				</div>
			</div>
			<div class="news">
				<a :href="news.link" target="_blank">
					<div class="newsImg">
						<img :src="news.value" alt="">
					</div>
					<div class="newsText" v-html="news.detail">
						{{news.detail}}
					</div>
				</a>

			</div>
		</div>
		<!-- 获奖履历 -->
		<div class="jiang  jiangHeight">
			<div class="title">
				<div class="bgimg">
					<img src="../assets/img/dd02.png" alt="">
				</div>
				<div class="text" @mouseenter="titleEnter($event)" @mouseleave="titleLeave($event)">
					<p class="name">获奖履历</p>
					<p class="english">AWARDS</p>
				</div>
			</div>
			<div class="resume">
				<div class="item" v-for="item in record" :key="item.index">
					<p class="item_name">{{item.title}} </p>
					<div class="item_prize" v-html="item.textBody">
						{{item.textBody}}
					</div>
					<!-- <p class="item_details">《陈情令》由肖战、王一博主演，以五大家族为背景，，以五大家族为背景，讲述了云梦江氏故人之子魏无羡和姑苏蓝氏含光君蓝忘机重遇，携手探寻往年真相，守护百姓和平安乐的故事。</p> -->
				</div>
				<!-- <div class="item">
					<p class="item_name">《陈情令》 </p>
					<div class="item_prize">
						<p>“第六届“文荣奖”佳导演奖”</p>
						<p>“华鼎奖全国十佳观众最喜爱电视演员”</p>
					</div>
					<p class="item_details">《陈情令》由肖战、王一博主演，以五大家族为背景，讲述了云梦江氏故人之子魏无羡和姑苏蓝氏含光君蓝忘机重遇，携手探寻往年真相，守护百姓和平安乐的故事。</p>
				</div>
				<div class="item">
					<p class="item_name">《陈情令》 </p>
					<div class="item_prize">
						<p>“第六届“文荣奖”佳导演奖”</p>
						<p>“华鼎奖全国十佳观众最喜爱电视演员”</p>
					</div>
					<p class="item_details">《陈情令》由肖战、王一博主演，以五大家族为背景，，以五大家族为背景，讲述了云梦江氏故人之子魏无羡和姑苏蓝氏含光君蓝忘机重遇，携手探寻往年真相，守护百姓和平安乐的故事。</p>
				</div>
				<div class="item">
					<p class="item_name">《陈情令》 </p>
					<div class="item_prize">
						<p>“第六届“文荣奖”佳导演奖”</p>
						<p>“华鼎奖全国十佳观众最喜爱电视演员”</p>
					</div>
					<p class="item_details">《陈情令》由肖战、王一博主演，以五大家族为背景，讲述了云梦江氏故人之子魏无羡和姑苏蓝氏含光君蓝忘机重遇，携手探寻往年真相，守护百姓和平安乐的故事。</p>
				</div> -->
			</div>

		</div>
	</div>


</template>

<script>
	export default {
		name: 'dynamic',
		data() {
			return {
				news: "",
				record: "",
				// jiangheight:"",
				queryNum: "", //监听当前路由是否发生变化
				newsHeight: "",
				jiangHeight: ""
			}
		},
		watch: {
			$route: {
				handler() {
					this.queryNum = this.$route.query.num;
					// this.getDetail();
					//深度监听，同时也可监听到param参数变化
				},
				deep: true,
			},
			queryNum(newValue, old) {
				if (newValue != old) {
					console.log("页面的值由" + old + "变为" + newValue)
					if (newValue == 41) {
						this.scroll1()
					} else if (newValue == 42) {
						this.scroll2()
					}
				}
			}
		},
		methods: {
			//鼠标移入标题
			titleEnter(e){
				let bgimg = e.target.previousElementSibling 
				bgimg.style.transform = 'scale(1.1,1.1)'
				bgimg.style.transitionDuration="1s"
			},
			//鼠标移出标题
			titleLeave(e){
				let bgimg = e.target.previousElementSibling 
				bgimg.style.transform = 'scale(1,1)'
				bgimg.style.transitionDuration="1s"
			},
			//获取新闻动态
			getNews() {
				this.$api.get(this.$httpApi + this.$path.INDEX_NEWS).then(res => {
					// console.log("新闻动态", res.data);
					this.news = res.data.data[0];
					this.scroll1();
				}).catch(err => {})
			},
			//获取获奖履历
			getRecord() {
				this.$api.get(this.$httpApi + this.$path.INDEX_RECORD).then(res => {
					// console.log("获奖履历", res.data);
					this.record = res.data.data
					this.scroll2()
				}).catch(err => {})
			},
			//滚动到新闻动态的高度
			scroll1() {
				this.$nextTick(() => {
					//获取高度
					let newsHeight = document.querySelector('.newsHeight')
					this.newsHeight = newsHeight.offsetTop
					//设置高度
					if (this.$route.query.num == 41) {
						let _this = this;
						setTimeout(function() {
							document.body.scrollTop = _this.newsHeight
							document.documentElement.scrollTop = _this.newsHeight
						}, 5);
					}
				})
			},
			//滚动到获奖履历的高度
			scroll2() {
				this.$nextTick(() => {
					//获取高度
					let jiangHeight = document.querySelector('.jiangHeight')
					this.jiangHeight = jiangHeight.offsetTop
					//设置高度
					if (this.$route.query.num == 2 || this.$route.query.num == 42) {
						let _this = this;
						setTimeout(function() {
							document.body.scrollTop = _this.jiangHeight
							document.documentElement.scrollTop = _this.jiangHeight
						}, 5);
					}

				})
			},
			//横板菜单滚动到页面指定位置
			Menuscroll(value){
				if(value==1){
					//获取高度
					let newsHeight = document.querySelector('.newsHeight')
					this.newsHeight = newsHeight.offsetTop
					//设置高度
					document.body.scrollTop = this.newsHeight
					document.documentElement.scrollTop = this.newsHeight
				}else if(value==2){
					let jiangHeight = document.querySelector('.jiangHeight')
					this.jiangHeight = jiangHeight.offsetTop
					//设置高度
					document.body.scrollTop = this.jiangHeight
					document.documentElement.scrollTop = this.jiangHeight
				}
			}
		},
		mounted() {
			this.getNews();
			this.getRecord();
			this.$router.afterEach((to, from, next) => {
				window.scrollTo(0, 0)
			})
		}
	}
</script>

<style scoped>
	.Box {
		width: 19.20rem;
	}

	/* 菜单 */
	.Menu {
		width: 100%;
		height: 0.4rem;
		background-color: #05060a;
		line-height: 0.20rem;
		padding-left: 5.10rem;
		box-sizing: border-box;
	}

	.menuText {
		color: #ffffff;
		font-size: 0.18rem;
		float: left;
		margin-right: 1rem;
		cursor: pointer;
	}

	/* 标题开始 */
	.title {
		width: 100%;
		height: 2.40rem;
		padding: 0 1.32rem;
		box-sizing: border-box;
		background-color: #0F0F0F;
		position: relative;
		border-bottom: 0.01rem solid #666666;
	}

	.bgimg {
		width: 1.86rem;
		height: 1.72rem;
		position: absolute;
		left: 1.32rem;
		top: 0.35rem;
	}

	.bgimg img {
		/* width: 100%; */
		height: 100%;
	}

	.text {
		min-width: 4.80rem;
		height: 2.00rem;
		position: absolute;
		left: 1.4rem;
		top: 0.40rem;
		z-index: 2;
	}
	.text:hover{
		cursor: pointer;
	}

	.name {
		color: #FFFFFF;
		font-size: 0.32rem;
		text-align: left;
		margin-top: 0.60rem;
		line-height: 0.50rem;
		font-weight: 500;
		letter-spacing: 0.03rem;
	}

	.english {
		color: #FFFFFF;
		font-size: 0.21rem;
		line-height: 0.30rem;
		font-weight: 5.00;
		text-align: left;
		margin-top: 0.1rem;
	}

	.det {
		color: #d5d5d5;
		font-size: 0.24rem;
		line-height: 0.20rem;
		position: absolute;
		bottom: 0;
		left: 0;
	}

	/* 标题结束 */
	.news {
		width: 100%;
		height: auto;
		padding: 0.60rem 1.34rem;
		box-sizing: border-box;
		background-color: #0F0F0F;
		border-bottom: 0.01rem solid #666666;
	}

	.newsImg {
		width: 16.24rem;
		height: 4.43rem;
		margin: 0 auto;
	}

	.newsImg img {
		width: 100%;
		height: 100%;
	}

	.newsText {
		width: 100%;
		height: auto;
		padding: 0.30rem 0.10rem;
		box-sizing: border-box;
		text-align: justify;
		font-size: 0.16rem;
		line-height: 0.35rem;
		color: #d9d9d9;
	}
     .newsText:hover{
		 color: #1996f6;
	 }
	.resume {
		width: 100%;
		height: auto;
		background-color: #0F0F0F;
		padding: 0.53rem 1.34rem;
		box-sizing: border-box;
		text-align: left;
	}

	.item {
		width: 100%;
		height: auto;
		color: #FFFFFF;
		margin-bottom: 0.70rem;
	}

	.item_name {
		width: 100%;
		font-size: 0.21rem;
		font-weight: 500;
		line-height: 0.30rem;
		margin-bottom: 0.08rem;
	}

	.item_prize {
		width: 100%;
		margin-bottom: 0.30rem;
		font-size: 0.16rem;
		line-height: 0.35rem;
		text-align: justify;
		color: #e3e3e3;
	}

	.item_details {
		width: 100%;
		font-size: 0.16rem;
	}
</style>



// WEBPACK FOOTER //
// src/pages/dynamic.vue